export const actionTypes = {
  SET_PRODUCT_MODE: 'SET_PRODUCT_MODE',
  HANDLE_CHANGE_OPEN_SIDEBAR: 'HANDLE_CHANGE_OPEN_SIDEBAR',
  OPEN_HIGHLIGHT_WEEK_DIALOG: 'OPEN_HIGHLIGHT_WEEK_DIALOG',
  SET_IS_PLAYING_VOICE_PODIUM: 'SET_IS_PLAYING_VOICE_PODIUM',
  SET_SHOW_PACKAGE_EXPIRING_SOON: 'SET_SHOW_PACKAGE_EXPIRING_SOON',
  SET_SHOW_NOTIFY_LOW_CREDITS: 'SET_SHOW_NOTIFY_LOW_CREDITS',
  SET_SHOW_ONBOARDING_POPUP: 'SET_SHOW_ONBOARDING_POPUP',
  SET_SHOW_ONBOARDING_TASKS: 'SET_SHOW_ONBOARDING_TASKS',
  SET_SHOW_ONBOARDING_POPUP_MOBILE: 'SET_SHOW_ONBOARDING_POPUP_MOBILE',
  SET_TASK_COMPLETED_DATA: 'SET_TASK_COMPLETED_DATA',
  SET_SHOW_COMPLETE_TASK_SURVEY_DIALOG: 'SET_SHOW_COMPLETE_TASK_SURVEY_DIALOG',
  SET_IS_PANEL_RESIZE_DISABLED: 'SET_IS_PANEL_RESIZE_DISABLED',
  SET_RECENT_PROJECTS_VIEW: 'SET_RECENT_PROJECTS_VIEW',
  SET_DUBBING_PANEL_VIEW: 'SET_DUBBING_PANEL_VIEW',
};

const setProductMode = (productMode) => ({
  type: actionTypes.SET_PRODUCT_MODE,
  productMode,
});

const handleChangeOpenSidebar = (openSidebar) => ({
  type: actionTypes.HANDLE_CHANGE_OPEN_SIDEBAR,
  openSidebar,
});

const openHighlightWeekDialog = (open) => ({
  type: actionTypes.OPEN_HIGHLIGHT_WEEK_DIALOG,
  open,
});

const setIsPlayingVoicePodium = (isPlaying) => ({
  type: actionTypes.SET_IS_PLAYING_VOICE_PODIUM,
  isPlaying,
});

const setShowPackageExpiringSoon = (showPackageExpiringSoon) => ({
  type: actionTypes.SET_SHOW_PACKAGE_EXPIRING_SOON,
  showPackageExpiringSoon,
});

const setShowNotifyLowCredits = (showNotifyLowCredits) => ({
  type: actionTypes.SET_SHOW_NOTIFY_LOW_CREDITS,
  showNotifyLowCredits,
});

const setShowOnboardingPopup = (showOnboardingPopup) => ({
  type: actionTypes.SET_SHOW_ONBOARDING_POPUP,
  showOnboardingPopup,
});

const setShowOnboardingTasks = (showOnboardingTasks) => ({
  type: actionTypes.SET_SHOW_ONBOARDING_TASKS,
  showOnboardingTasks,
});

const setShowOnboardingPopupMobile = (showOnboardingPopupMobile) => ({
  type: actionTypes.SET_SHOW_ONBOARDING_POPUP_MOBILE,
  showOnboardingPopupMobile,
});

const setTaskCompletedData = (taskCompletedData) => ({
  type: actionTypes.SET_TASK_COMPLETED_DATA,
  taskCompletedData,
});

const setShowCompleteTaskSurveyDialog = (showCompleteTaskSurveyDialog) => ({
  type: actionTypes.SET_SHOW_COMPLETE_TASK_SURVEY_DIALOG,
  showCompleteTaskSurveyDialog,
});

const setIsPanelResizeDisabled = (isDisabled) => ({
  type: actionTypes.SET_IS_PANEL_RESIZE_DISABLED,
  isDisabled,
});

const setRecentProjectsView = (recentProjectsView) => ({
  type: actionTypes.SET_RECENT_PROJECTS_VIEW,
  recentProjectsView,
});

const setDubbingPanelView = (dubbingPanelView) => ({
  type: actionTypes.SET_DUBBING_PANEL_VIEW,
  dubbingPanelView,
});

export {
  setProductMode,
  handleChangeOpenSidebar,
  openHighlightWeekDialog,
  setIsPlayingVoicePodium,
  setShowPackageExpiringSoon,
  setShowNotifyLowCredits,
  setShowOnboardingPopup,
  setShowOnboardingTasks,
  setShowOnboardingPopupMobile,
  setTaskCompletedData,
  setShowCompleteTaskSurveyDialog,
  setIsPanelResizeDisabled,
  setRecentProjectsView,
  setDubbingPanelView,
};
